// HTTP请求工具类
import axios from 'axios';
import {Message, MessageBox} from 'element-ui'
import router from '@/router'
import {getToken, removeToken} from '@/utils/auth'
// 创建axios实例
const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

// 请求拦截器
request.interceptors.request.use(
    config => {
        if (getToken()) {
            config.headers['x-access-token'] = getToken();
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

// 响应拦截器
request.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 200) {
            if (res.code === 401) {
                // 先清除 token，避免跳转后再次触发 401
                removeToken()
                MessageBox.confirm('登录失效，请重新登录', '提示', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    router.replace('/')
                })
                return Promise.reject(res)
            } else if (res.code === 201) {
                return Promise.reject(res)
            } else {
                Message({
                    message: res.result || 'Error',
                    type: 'error',
                    duration: 1.5 * 1000
                })
            }
            return Promise.reject(new Error(res.result || 'Error'))
        } else {
            return res
        }
    },
    error => {
        return Promise.reject(error);
    },
);

export default request;
